// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".6022952de4b08e13a9c11d2d5c8f7b15.js";
};